import { useCallback, useSyncExternalStore } from 'react';

/** Unterhalb dieser Breite gilt das Mobile-Layout (Top-Bar + Vollbild-Menü), entspricht `--breakpoint-sm` */
export const MOBILE_MEDIA_QUERY = '(max-width: 769.98px)';

// jsdom (Tests) kennt kein matchMedia
const hasMatchMedia = () => typeof window !== 'undefined' && typeof window.matchMedia === 'function';

/**
 * Liefert `true`, solange das Mobile-Layout aktiv ist. Folgt Resize/Rotation ohne eigene Resize-Listener.
 * TODO: durch `useBreakpoint().isMobile` aus @bp/ui-components ersetzen, sobald released.
 */
export const useIsMobile = (): boolean => {
  const subscribe = useCallback((onChange: () => void) => {
    if (!hasMatchMedia()) {
      return () => undefined;
    }
    const mql = window.matchMedia(MOBILE_MEDIA_QUERY);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  const getSnapshot = useCallback(() => hasMatchMedia() && window.matchMedia(MOBILE_MEDIA_QUERY).matches, []);

  return useSyncExternalStore(subscribe, getSnapshot, () => false);
};
